import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkLabelCountRequest = {};
var _bulkLabelCountResponse = {};
var _countRequest = {};
var _countResponse = {};
var _deleteContext = { dateDeleted: 'google.protobuf.Timestamp' };
var _metaSiteSearchEntry = {
    dateCreated: 'google.protobuf.Timestamp',
    dateUpdated: 'google.protobuf.Timestamp',
    deleteContext: '_deleteContext',
};
var _searchRequest = { responseData: 'google.protobuf.FieldMask' };
var _searchResponse = { entries: '_metaSiteSearchEntry' };
var _validateSiteNameByOwnerRequest = {};
var _validateSiteNameByOwnerResponse = {};
function resolveComWixpressMetasiteSearchApiV2MetaSiteSearchApiV2Url(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/meta-site-search-web',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/meta-site-search-web',
                destPath: '',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/meta-site-search-web/v2/search',
                destPath: '/v2/search',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/meta-site-search-web',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/meta-site-search-web',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/meta-site-search-web/v2/search',
                destPath: '/v2/search',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Searches meta sites according to provider filters. */
export function search(payload) {
    var _a = serializer(_searchRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchResponse, {
        _deleteContext: _deleteContext,
        _metaSiteSearchEntry: _metaSiteSearchEntry,
    }).fromJSON;
    function __search(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.metasite.search.v2.search_entry',
            method: 'POST',
            methodFqn: 'com.wixpress.metasite.search.api.v2.MetaSiteSearchApiV2.Search',
            url: resolveComWixpressMetasiteSearchApiV2MetaSiteSearchApiV2Url({
                protoPath: '/v2/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __search.fromReq = fromReq;
    __search.__isAmbassador = true;
    return __search;
}
/** Validates if the provided site name can be used for a new site. */
export function validateSiteNameByOwner(payload) {
    var _a = serializer(_validateSiteNameByOwnerRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateSiteNameByOwnerResponse, {}).fromJSON;
    function __validateSiteNameByOwner(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.metasite.search.v2.search_entry',
            method: 'POST',
            methodFqn: 'com.wixpress.metasite.search.api.v2.MetaSiteSearchApiV2.ValidateSiteNameByOwner',
            url: resolveComWixpressMetasiteSearchApiV2MetaSiteSearchApiV2Url({
                protoPath: '/v2/validate-site-name',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateSiteNameByOwner.fromReq = fromReq;
    __validateSiteNameByOwner.__isAmbassador = true;
    return __validateSiteNameByOwner;
}
/** Returns number of meta sites that match provided filters. */
export function count(payload) {
    var _a = serializer(_countRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countResponse, {}).fromJSON;
    function __count(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.metasite.search.v2.search_entry',
            method: 'POST',
            methodFqn: 'com.wixpress.metasite.search.api.v2.MetaSiteSearchApiV2.Count',
            url: resolveComWixpressMetasiteSearchApiV2MetaSiteSearchApiV2Url({
                protoPath: '/v2/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __count.fromReq = fromReq;
    __count.__isAmbassador = true;
    return __count;
}
/** For restricted team members only. Counts label in bulk. */
export function bulkLabelCount(payload) {
    var _a = serializer(_bulkLabelCountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkLabelCountResponse, {}).fromJSON;
    function __bulkLabelCount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.metasite.search.v2.search_entry',
            method: 'POST',
            methodFqn: 'com.wixpress.metasite.search.api.v2.MetaSiteSearchApiV2.BulkLabelCount',
            url: resolveComWixpressMetasiteSearchApiV2MetaSiteSearchApiV2Url({
                protoPath: '/v2/bulk-label-count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkLabelCount.fromReq = fromReq;
    __bulkLabelCount.__isAmbassador = true;
    return __bulkLabelCount;
}
//# sourceMappingURL=http.impl.js.map